// extracted by mini-css-extract-plugin
export default {"card":"x0-z","carouselContainer":"y0-z","carouselContent":"z0-z"};